import type { Star } from '../api/practices.js';

/** The star shapes and colours of boards R1 and R2. A diamond is its own shape. */
const FILL: Record<Star, string> = { bronze: '#CD7F32', silver: '#C9D1DB', gold: '#F2C230', diamond: '#7FE3F0' };
const NAME: Record<Star, string> = { bronze: 'Bronze star', silver: 'Silver star', gold: 'Gold star', diamond: 'Diamond' };

export function PracticeStar({ star, size = 18, label }: { star: Star; size?: number; label?: string }) {
  return (
    <svg className="practice-star" width={size} height={size} viewBox="0 0 24 24" role="img" aria-label={label ?? NAME[star]}>
      <polygon
        points={star === 'diamond' ? '12,2 21,10 12,22 3,10' : '12,2 14.9,8.6 22,9.3 16.6,14 18.2,21 12,17.3 5.8,21 7.4,14 2,9.3 9.1,8.6'}
        fill={FILL[star]}
      />
    </svg>
  );
}
